import { render, staticRenderFns } from "./conferencesAndBanquets.vue?vue&type=template&id=6d8f2ef2&scoped=true"
import script from "./conferencesAndBanquets.vue?vue&type=script&lang=js"
export * from "./conferencesAndBanquets.vue?vue&type=script&lang=js"
import style0 from "./conferencesAndBanquets.vue?vue&type=style&index=0&id=6d8f2ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f2ef2",
  null
  
)

export default component.exports